module.exports = __webpack_public_path__ + "static/alentic-logo-3768e5442f4e977e02fca410271cbd9c.png";